import { render, staticRenderFns } from "./WhatsappEnrichmentIframeModal.vue?vue&type=template&id=5385d1fa&scoped=true&"
import script from "./WhatsappEnrichmentIframeModal.vue?vue&type=script&lang=ts&"
export * from "./WhatsappEnrichmentIframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsappEnrichmentIframeModal.vue?vue&type=style&index=0&id=5385d1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385d1fa",
  null
  
)

export default component.exports